import React, { useEffect, useRef, useState } from "react";
import orderModel from "../../model/order.model";
import moment from "moment";
import { IoMdArrowForward } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import back from "../../Asset/product/back.png";
import { type } from "@testing-library/user-event/dist/type";
import { IoCloseCircle } from "react-icons/io5";
import { FaCirclePause } from "react-icons/fa6";
import { IoMdPause } from "react-icons/io";
import { toast } from "../../lib/helper";
import { FaPlay } from "react-icons/fa";
import logo from "../../Asset/ordercard/logo.png";
import { FaBoxOpen } from "react-icons/fa6";
import DatePicker from "react-datepicker";

const Order = () => {
  const Navigate = useNavigate();
  const [orderList, setOrderList] = useState();
  const [loading, setLoading] = useState(false);
  const [ordertype, setOrdertype] = useState("regular");
  const [status, setStatus] = useState("sheduled");
  const [orderstatus, setorderStatus] = useState("active");
  const [date, setDate] = useState(null);

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const GetOrder = async () => {
    setLoading(true);

    const params = {
      order_type: ordertype,
    };

    if (params.order_type == "pre_order") {
      params.status = status;
    }
    if (params.order_type == "subscription") {
      params.status = orderstatus;
    }
    if (date) {
      params.date = date;
    }
    orderModel
      .GetOrders(params)
      .then((response) => {
        setOrderList(response?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  };
  useEffect(() => {
    GetOrder();
  }, []);
  useEffect(() => {
    GetOrder();
  }, [ordertype, status, orderstatus, date]);
  console.log("ddd order", orderList);
  const changeStatus = async (id, statuss) => {
    const form = new FormData();
    form.append("subscription_order_status", statuss);
    orderModel
      .UpdateOrder(id, form)
      .then((responce) => {
        console.log("responce", responce);
        toast(responce?.data?.message, logo);
        GetOrder();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const dateInputRef = useRef(null);
  console.log("date", orderList);
  return (
    <div
      className="w-full bg-Background3 px-8 lg:pl-20 lg:pr-20 pt-20 pb-32 md:pb-60"
      style={{ backgroundImage: `url(${back})` }}
    >
      <div className="w-full my-6">
        <span className="text-textColor font-bold text-2xl flex items-center gap-2">
          <FaBoxOpen className="text-5xl" />{" "}
          {ordertype == "regular" && " My Orders"}{" "}
          {ordertype == "pre_order" && "My Pre Orders"}{" "}
          {ordertype == "subscription" && "My Subscription Orders "}
        </span>
      </div>
      <div>
        <div className=" w-full md:w-3/4 flex gap-2 bg-Background1 p-2 lg:p-3 rounded-xl">
          <span
            className={`w-40 ${
              ordertype == "regular" && "bg-Background2"
            } text-lg title1 lg:text-xl font-bold text-textColor text-center rounded-lg py-1  cursor-pointer`}
            onClick={() => {
              setDate(null);
              setOrdertype("regular");
              setStatus("");
            }}
          >
            Order
          </span>
          <span
            className={`w-40 ${
              ordertype == "pre_order" && "bg-Background2"
            } text-lg lg:text-xl title1 font-bold text-textColor text-center rounded-lg  py-1  cursor-pointer`}
            onClick={() => {
              setDate(null);
              setOrdertype("pre_order");
              setStatus("sheduled");
              setorderStatus("");
            }}
          >
            Pre Order
          </span>
          <span
            className={`w-40 ${
              ordertype == "subscription" && "bg-Background2"
            } text-lg title1 lg:text-xl font-bold text-textColor text-center rounded-lg py-1  cursor-pointer`}
            onClick={() => {
              setDate(null);
              setOrdertype("subscription");
              setorderStatus("active");
              setStatus("");
            }}
          >
            Subscribe
          </span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mt-8">
        {ordertype == "pre_order" && (
          <div className="flex gap-8 ">
            <span
              className={`w-24 rounded-2xl text-sm font-semibold flex justify-center py-1.5  cursor-pointer ${
                status == "sheduled"
                  ? "bg-textColor text-white"
                  : "bg-Background2"
              }`}
              onClick={() => {
                setStatus("sheduled");
              }}
            >
              Scheduled
            </span>
            <span
              className={`w-24 rounded-2xl text-sm font-semibold flex justify-center py-1.5 cursor-pointer ${
                status == "delivered"
                  ? "bg-textColor text-white"
                  : "bg-Background2"
              }`}
              onClick={() => {
                setStatus("delivered");
              }}
            >
              Delivered
            </span>
          </div>
        )}
        {ordertype == "subscription" && (
          <div className="flex gap-8 ">
            <span
              className={`w-24 rounded-2xl text-sm font-semibold flex justify-center py-1.5  cursor-pointer  ${
                orderstatus == "active"
                  ? "bg-textColor text-white"
                  : "bg-Background2"
              }`}
              onClick={() => {
                setorderStatus("active");
              }}
            >
              Active
            </span>
            <span
              className={`w-24 rounded-2xl text-sm font-semibold flex justify-center py-1.5 cursor-pointer ${
                orderstatus == "inactive"
                  ? "bg-textColor text-white"
                  : "bg-Background2"
              }`}
              onClick={() => {
                setorderStatus("inactive");
              }}
            >
              Inactive
            </span>
          </div>
        )}
        {ordertype === "subscription" && (
          <div className="relative w-28">
            <DatePicker
              selected={date}
              onChange={(date) => setDate(date)}
              placeholderText="Select Date"
              dateFormat="dd-MM-yyyy"
              maxDate={new Date()}
              className="px-3 py-1 rounded-2xl bg-gray-100 w-full text-gray-700 cursor-pointer"
            />
          </div>
        )}
      </div>
      {loading ? (
        <div className="w-full h-[216px] p-8 flex justify-center items-center">
          <span className="loading loading-ring loading-xs"></span>
          <span className="loading loading-ring loading-sm"></span>
          <span className="loading loading-ring loading-md"></span>
          <span className="loading loading-ring loading-lg"></span>
          <span className="loading loading-ring loading-xl"></span>
          <span className="loading loading-ring loading-lg"></span>
          <span className="loading loading-ring loading-md"></span>
          <span className="loading loading-ring loading-sm"></span>
          <span className="loading loading-ring loading-xs"></span>
        </div>
      ) : (
        <>
          {/* items section */}
          <div className="pb-14">
            {orderList?.length > 0 ? (
              orderList.map((item, index) => (
                <div
                  className={`mt-10 w-[100%] md:w-[90%] bg-Background1 rounded-2xl cursor-pointer ${
                    ordertype == "subscription" && "cursor-pointer"
                  }`}
                  key={index}
                  onClick={() => {
                    Navigate(`/orderdetail/${item?._id}`);
                  }}
                >
                  <div className="px-4 lg:px-16 pt-7 flex justify-between">
                    <div className="cursor-pointer underline text-sm">
                      <span className="">Order: </span>
                      <span>#{item?.unique_order_id}</span>
                    </div>
                    <div className="flex flex-col  ">
                      <span className="text-xs title1 text-gray-400">
                        Ordered on{" "}
                        {moment(item?.createdAt).format("DD MMM YYYY")}
                      </span>
                      <span className="text-xs text-gray-400">
                        {moment(item?.createdAt).format("hh:mm A")}
                      </span>
                    </div>
                  </div>
                  <div className="px-4 lg:px-16  flex flex-col md:flex-row md:justify-between justify-start ">
                    <span>
                      {ordertype === "regular" && (
                        <span className="title2 text-sm">
                          <span className="font-semibold">
                            Estimated Delivery{" "}
                          </span>
                          10 Feb 2025 (6 AM to 8 AM)
                        </span>
                      )}

                      {ordertype == "pre_order" && (
                        <span className="text-sm">
                          <span className="font-semibold">Pre Ordered For</span>{" "}
                          {item?.pre_order_date} ({item?.pre_order_time})
                        </span>
                      )}

                      {ordertype == "subscription" && (
                        <span className="text-sm">
                          <span className="font-semibold">
                            Subscription start from{" "}
                          </span>
                          {item?.subscription_start_from}
                          <div className="flex flex-wrap gap-2 title1">
                            <span className="font-semibold">
                              Subscription For
                            </span>
                            <div className="flex flex-wrap gap-2">
                              {(item?.subscription_days?.length > 0 &&
                                item.subscription_days[0]
                                  ?.split(",")
                                  .map((day, index) => (
                                    <button
                                      key={index}
                                      className="px-2 py-0 text-white font-bold text-[8px] rounded-xl bg-textcolor2"
                                    >
                                      {day.trim()}
                                    </button>
                                  ))) || <span>No days available</span>}
                            </div>
                          </div>
                        </span>
                      )}
                    </span>
                    <div className="pr-[50px] font-semibold text-[14px]">
                      <span className="title2">Total </span>
                      <span className="title2  "> ₹ {item?.total}</span>
                    </div>
                  </div>

                  {item?.items?.map((subItem, subIndex) => (
                    <div
                      className="px-4 lg:px-20 flex justify-between items-center mt-4"
                      key={subIndex}
                    >
                      <div className="flex gap-4 items-center">
                        <div className="w-20 h-20 rounded-md">
                          <img
                            src={subItem?.product_id?.profile_image?.location}
                            className="w-full h-full object-cover rounded-md"
                            alt="img"
                          />
                        </div>
                        <div className="flex flex-col">
                          <span className="title1">
                            {subItem?.product_id?.name}
                          </span>
                          <span className="title2 font-bold text-[#8F8F8F] text-base">
                            {subItem?.quantity} {subItem?.product_id?.unit_type}
                          </span>
                        </div>
                      </div>
                      <div className="bg-white py-2 px-3 flex gap-5 rounded-3xl items-center shadow-md">
                        <span>Qty</span>
                        <div className="w-8 h-8 bg-Background2 rounded-full flex justify-center items-center">
                          {subItem?.quantity}{" "}
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="p-2 sm:p-4 w-full flex justify-end">
                    {/*ordertype !== "subscription" && (
                      <span
                        className="w-12 h-12 rounded-full flex justify-center items-center bg-textColor text-white cursor-pointer"
                        onClick={() => {
                          Navigate(`/orderdetail/${item?._id}`);
                        }}
                      >
                        <IoMdArrowForward className="text-2xl" />
                      </span>
                    )*/}
                    {ordertype === "subscription" &&
                      item?.status !== "delivered" &&
                      item?.status !== "inactive" && (
                        <div className="flex gap-6 flex-col lg:flex-row">
                          <button
                            type="button"
                            className="flex items-center gap-2 font-bold bg-red-400 pr-5 pl-0.5 rounded-4xl text-white transform transition duration-300 hover:scale-105"
                            onClick={(e) => {
                              e.stopPropagation();
                              changeStatus(item?._id, "cancel");
                            }}
                          >
                            <IoCloseCircle className="text-5xl" /> Cancel
                            Subscription
                          </button>
                          <button
                            className="flex items-center gap-2 font-bold bg-Background2 py-2 px-3 rounded-4xl text-gray-600 transform transition duration-300 hover:scale-105"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (item?.subscription_order_status !== "pause") {
                                changeStatus(item?._id, "pause");
                              } else {
                                changeStatus(item?._id, "active");
                              }
                            }}
                          >
                            <div className="p-2 rounded-full bg-Background1 ">
                              {item?.subscription_order_status === "pause" ? (
                                <FaPlay />
                              ) : (
                                <IoMdPause className="text-xl" />
                              )}
                            </div>
                            {item?.subscription_order_status === "pause"
                              ? "Continue"
                              : "Pause"}{" "}
                            Subscription
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center h-40">
                <span className="text-lg title1 font-semibold text-textColor">
                  No item found
                </span>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Order;
